// Orden calendario (año escolar) usado como respaldo cuando no se puede
// confiar en el orden de las llaves devueltas por el back.
export const MONTHS_ORDER = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
];

/**
 * Obtiene la lista de meses a mostrar, en orden cronológico.
 *
 * El back (`/treasury/debtors-report-by-month`) devuelve `monthlyTotals` con
 * las llaves ya en orden (MARZO...mes seleccionado), así que se usa como
 * fuente principal. Cada estudiante trae solo los meses que adeuda dentro de
 * `debts`, por lo que nunca hay que tomar los meses de un solo estudiante
 * (el primero de la lista puede deber, por ejemplo, solo AGOSTO) sino la
 * unión de todos.
 */
export function getOrderedMonths(monthlyTotals?: Record<string, any>, studentDebts?: any[]): string[] {
    const monthlyTotalsKeys = monthlyTotals ? Object.keys(monthlyTotals) : [];
    if (monthlyTotalsKeys.length > 0) return monthlyTotalsKeys;

    const monthsSet = new Set<string>();
    studentDebts?.forEach((item: any) => {
        item?.debts?.forEach((d: any) => monthsSet.add(d.description));
    });

    return MONTHS_ORDER.filter((month) => monthsSet.has(month));
}
